module.exports = __webpack_public_path__ + "media/images/1200/circadian_rhytm_mimosa_pudica-8f3ebb8eee2da2f2c972479def4ab7b6.webp";